export const Tooltip = ({ message, children }) => {
  return (
    <div className="group relative inline-flex">
      {children}
      <span
        className="
          pointer-events-none absolute z-30 bottom-full left-1/2 -translate-x-1/2 mb-2
          whitespace-nowrap max-w-xs px-2.5 py-1.5 rounded-lg
          bg-ink text-white text-xs font-medium leading-tight
          opacity-0 scale-95 origin-bottom
          group-hover:opacity-100 group-hover:scale-100
          transition-all duration-150 ease-out
          shadow-card-md
        "
      >
        {message}
        {/* Arrow */}
        <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-ink" />
      </span>
    </div>
  );
};
